import { Component, Input, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-all-game-log',
  templateUrl: './all-game-log.component.html',
  styleUrls: ['./all-game-log.component.scss']
})
export class AllGameLogComponent {

  public data:any = {};
  public items:any = [];
  public error_message:any;
  public load = false;
  public content:any;
  private timezone = '+08:00';

  // Per-row expand state for the sportsbook match-detail drawer.
  public expanded: any = {};

  @Input() set setData(v:any) {
    this.data = v;

    let date = new Date()
    let endDate = new Date()
    date.setMinutes(date.getMinutes() - 35)
    endDate.setMinutes(endDate.getMinutes() - 5)
    this.data.date_from = this.formatDateWithTimezoneOffset(date).slice(0, 16)
    this.data.date_to = this.formatDateWithTimezoneOffset(endDate).slice(0, 16)
  }
  constructor(private http: HttpService) {
    this.http.post('/admin/company/setting').then((rtn: any) => {
      if (rtn?.setting?.timezone) this.timezone = rtn.setting.timezone;
    });
  }
  formatDateWithTimezoneOffset(date) {
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let day = String(date.getDate()).padStart(2, '0');

    let hours = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getMinutes()).padStart(2, '0');

    const tz = this.timezone;
    return `${year}-${month}-${day}T${hours}:${minutes}${tz}`;
}

  async filter() {
    this.error_message = null;
    this.content = null;
    let y:any = await this.http.post("/admin/integrated-game/all-player-log", this.data);
    this.load = true;

    if(!y.status && y.message) {
      this.error_message = y.message;
      return;
    }
    
    this.items = y.items;
  }

  async view(item) {
    this.content = null;
    let y:any = await this.http.post("/admin/integrated-game/bet-detail", {...this.data, item});
    this.load = true;

    if(y.message || y.content) {
      this.content = y.message ?? y.content;
    }

  }

  // ---- Sportsbook match detail (bet.game_detail = AWC gameInfo.legs[]) ----
  // NOTE: this view fetches provider-direct records (transfer-wallet slot providers), which do
  // not carry sportsbook legs today — these helpers stay inert (hasDetail=false → renders "—")
  // unless a record happens to include a game_detail object, keeping the column future-proof.

  hasDetail(item: any): boolean {
    const gd = item && item.game_detail;
    return !!(gd && Array.isArray(gd.legs) && gd.legs.length > 0);
  }

  matchSummary(item: any): string {
    if (!this.hasDetail(item)) return '';
    const legs = item.game_detail.legs;
    const first = legs[0] || {};
    const event = first.eventName || ((first.homeTeam && first.awayTeam) ? (first.homeTeam + ' vs ' + first.awayTeam) : '');
    const head = (first.sportName || item.game_detail.sportName || 'Match');
    let label = event ? (head + ': ' + event) : head;
    if (legs.length > 1) label += ' (+' + (legs.length - 1) + ' more)';
    return label;
  }

  toggleExpand(item: any) {
    if (!this.hasDetail(item)) return;
    const k = '' + (item.bet_id ?? item.transaction_id ?? item.id);
    this.expanded[k] = !this.expanded[k];
  }

  isExpanded(item: any): boolean {
    return !!this.expanded['' + (item.bet_id ?? item.transaction_id ?? item.id)];
  }

  legSelection(leg: any): string {
    const parts: string[] = [];
    if (leg.marketName || leg.betType) parts.push(leg.marketName || leg.betType);
    let sel = leg.selection || '';
    if (leg.handicap !== null && leg.handicap !== undefined && leg.handicap !== '') {
      const h = parseFloat(leg.handicap);
      sel += (Number.isFinite(h) ? (' ' + (h > 0 ? '+' : '') + h) : (' ' + leg.handicap));
    }
    if (sel) parts.push(sel.trim());
    let line = parts.join(' → ');
    if (leg.odds !== null && leg.odds !== undefined) line += '  @ ' + leg.odds;
    return line.trim();
  }

  legResultClass(leg: any): string {
    const s = ('' + (leg.legStatus || '')).toUpperCase();
    if (s.indexOf('WON') !== -1 || s === 'WIN') return 'text-success';
    if (s.indexOf('LOST') !== -1 || s.indexOf('LOSE') !== -1) return 'text-danger';
    if (s.indexOf('VOID') !== -1 || s.indexOf('CANCEL') !== -1 || s.indexOf('REFUND') !== -1) return 'text-muted';
    return '';
  }

}
